module.exports = {"540121100":"甘丹曲果镇","540121200":"春堆乡","540121201":"松盘乡","540121202":"强嘎乡","540121203":"卡孜乡","540121204":"边交林乡","540121205":"江热夏乡","540121206":"阿朗乡","540121207":"唐古乡","540121208":"旁多乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540121.json
// module id = 2484
// module chunks = 0